/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner, Button, Container, Row, Col } from "reactstrap";
import Header from "../../components/Header";
import NotificationAlert from "react-notification-alert";
import { getBrandData } from '../../api/request';
import { setToken } from '../../utils/token';
import { primaryColor } from '../../utils/colors';

const sWidth = window.screen.availWidth;

export default function Category() {
  const notificationAlertRef = React.useRef(null);
  const navigate = useNavigate();
  const { bn } = useParams();
  const [loading, setLoading] = useState({brand: false, pieces: true});
  const [error, setError] = useState({brand: false, pieces: false});
  const [brand, setBrand] = useState({id: '', 
    name: '',
    code: '',
    logo: ''
  });
  const [category, setCategory] = useState([]);

  useEffect(() => {
    getBrand();
  }, []);

  const getBrand = async () => {
    setLoading({...loading, brand: true});
    const res = await getBrandData(bn);
    const _data = res.data.data;

    if(res.status === 200) {
      setBrand(_data);
      setCategory(_data.categories);
      setError({...error, brand: false});
    }
    else {
      setBrand('');
      setError({...error, brand: true});
    }
    
    setLoading({...loading, brand: false});
  }

  const printText = (txt) => {
    if(sWidth <= 375 && sWidth > 321) {
      return (txt.length >= 18) ? `${txt.substr(0,15)}...` : txt;
    }
    else {
      return txt;
    }
  }

  const goToPiece = async (pieceToGo) => {
    setToken("scrollTop", JSON.stringify({ top: window.pageYOffset, brand: bn, category: category}));
    navigate(`/brand/${bn}/${pieceToGo}`);
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <Header back />
      <div style={{
        display: 'block',
        textAlign: "center",
        borderBottom: `1px solid ${primaryColor}`,
        backgroundColor: '#fff'
      }}>
        {
          (loading.brand) ? 
          <>
            <Spinner style={{
              color: primaryColor
            }} />
            <br /> <br />
          </> : 
          <>
            {
              (error.brand) ? <>
                <div style={{
                  marginTop: '15px',
                  textAlign: 'center'
                }}>
                  <p>Se ha presentado un error.Por favor intente de nuevo mas tarde.</p>
                  <Button style={{
                    backgroundColor: primaryColor,
                    border: 0
                  }}
                    onClick={() => getBrand()}> Cargar de nuevo </Button>
                </div>
              </> : 
              <>
                <img className="piecePicture" alt="..." src={brand.logo} />
                <h2>{brand.name}</h2>
              </>
            }
          </>
        }
      </div>

      <Container>
        <Row style={{
          marginTop: '15px',
          justifyContent: 'center'
        }}>
          {
            (loading.brand) ? 
            <>
              <div className="text-center">
                <Spinner style={{
                  color: primaryColor
                }} />
              </div>
              <br /> <br />
            </> : 
            <>
              {
                category.map((c, i) => {
                  return (
                    <Col 
                      md="4" 
                      key={i}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <div className="contPiece">
                        <div onClick={() => goToPiece(c.id)} className="linkToPiece">
                          <img className="piecePicture" alt="Imagen no disponible" src={c.logo} />
                          <span 
                            style={{
                              fontWeight: 'bold',
                              fontSize: '18px',
                            }}
                            className="pieceTitle">{printText(c.name)}</span>
                        </div>
                      </div>
                    </Col>
                  );
                })
              }

            </>
          }
        </Row>
      </Container>
    </>
  )
}

